import { api } from './api';

export const activityTimeEntry = api.injectEndpoints({
    endpoints: (builder) => ({
        getInProgressList: builder.query({
            query: (payload) => ({
                url: 'api/activity-log/time-entry',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),
        getSignedList: builder.query({
            query: (payload) => ({
                url: 'api/report/zero-claim-report/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),
        lockUnlockAnctivityEntry: builder.mutation({
            query: (payload) => ({
                url: 'api/activity-log/time-entry',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'unlock'
                }
            })
            // invalidatesTags: (result, error, arg) => (result ? ['SessionDetails', 'SessionList'] : [])
        }),
        getTimeSheetHistory: builder.query({
            query: (payload) => ({
                url: '/api/activity-log/activity/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
            // invalidatesTags: ['TreatmentHistory']
        })
        // downloadZeroClaimsReports: builder.query({
        //     query: (payload) => ({
        //         url: 'api/report/zero-claim-report/',
        //         method: 'POST',
        //         body: payload,
        //         headers: {
        //             SUBTYPE: 'list'
        //         },

        //         responseHandler: (res) =>
        //             res.blob().then((blob) => ({
        //                 blob,
        //                 fileName: res.headers.get('content-disposition').split('filename=')[1],
        //                 type: res.headers.get('content-type')
        //             }))
        //     })
        // })
    })
});

export const {
    // useLazyDownloadZeroClaimsReportsQuery,
    useLazyGetInProgressListQuery,
    useLazyGetSignedListQuery,
    useLockUnlockAnctivityEntryMutation,
    useLazyGetTimeSheetHistoryQuery
} = activityTimeEntry;